import Rails from "@rails/ujs";

Rails.href = function(element) { return element.dataset.url || element.href; }
